module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content"
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hbshow),
      expression: "hbshow"
    }],
    staticClass: "hb",
    attrs: {
      "src": _vm.hbImg
    },
    on: {
      "click": _vm.hbClick
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "group"
  }, [_c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noEffective),
      expression: "!noEffective"
    }]
  }, [_vm._v(_vm._s(_vm.integration))]), _vm._v(" "), _c('h2', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.noEffective),
      expression: "!noEffective"
    }]
  }, [_vm._v("积分")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noEffective),
      expression: "noEffective"
    }]
  }, [_vm._v("亲，这个红包已经失效了哦！")]), _vm._v(" "), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.noEffective),
      expression: "noEffective"
    }],
    staticStyle: {
      "margin-bottom": "20%"
    }
  }, [_vm._v("试试其他功能吧！")]), _vm._v(" "), _c('flexbox', [_c('flexbox-item', [_c('a', {
    staticClass: "btn",
    attrs: {
      "native": "$router.push('/integralMall?openid=')",
      "type": "warn"
    }
  }, [_vm._v("积分兑换")])])], 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2de7f0de","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vux-loader/src/before-template-compiler-loader.js!./node_modules/vux-loader/src/template-loader.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/project/IntegralProject/IntegralRedPacket.vue
// module id = 9K7X
// module chunks = 7